import { Image, Skeleton, Tag } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import Container from "../../General/Container/Container";
import targetgreen from "../../../images/target/targetgreen.png"
import targetblue from "../../../images/target/targetblue.png"
import targetorange from "../../../images/target/targetorange.png"

const PersonasTargetItem = ({ text, classColor, loading, style = {}, forPrint }) => {
    const dispatch = useDispatch()
    const getImage = () => {
        switch (classColor.trim()) {
            case "green": return targetgreen
            case "blue": return targetblue
            default: return targetorange
        }
    }
    return <Container className="personas-targetlock-item dcol" style={style}>
        {loading
            ? <Skeleton paragraph={{ rows: 1 }} active />
            : <Tag
                icon={<div className="personas-targetlock-title-imgcont">
                    <Image src={getImage()} preview={false} />
                </div>}
                className={`personas-targetlock-title${classColor}`}
            >
                <p className={`personas-targetlock-text${classColor}`}>{text}</p>
            </Tag>
        }
    </Container>
}

export default PersonasTargetItem